module.exports = __webpack_public_path__ + "img/company.3270307.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/company.png
// module id = EbL7
// module chunks = 1